module.exports = __webpack_public_path__ + "static/shaky-ground-efd10add9522d8f3dee0936b7117f420.gif";